export default __webpack_public_path__ + "static/media/rounded_arrow.201e554d.svg";